import type { AuthRole } from "@noverik/contracts";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { AppShell } from "./AppShell";

type Props = {
  role: Extract<AuthRole, "client" | "agent">;
};

export function ProtectedArea({ role }: Props) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="session-loading">
        <div className="brand-mark">N</div>
        <strong>Carregando Noverik Desk...</strong>
      </div>
    );
  }

  if (!session?.authenticated || !session.user) {
    return (
      <Navigate
        to={role === "agent" ? "/desk/login" : "/login"}
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  const allowed = role === "client"
    ? session.user.role === "client"
    : session.user.role === "agent" || session.user.role === "admin";

  if (!allowed) {
    return (
      <Navigate
        to={session.user.role === "client" ? "/" : "/desk"}
        replace
      />
    );
  }

  return <AppShell />;
}
